import { ArrowDownBoldOutlineIcon } from './ArrowDownBoldOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 517A69FA-E66C-469C-908F-E0CD723EBE8A
 * name arrow-down-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoldOutlineIcon = ArrowDownBoldOutlineIcon;
export default ArrowBottomBoldOutlineIcon